import keyMirror from 'keymirror'

export default keyMirror({
  GET_LOG_SWITCH_TO_REQUEST: null,
  GET_LOG_SWITCH_TO_SUCCESS: null,
  GET_LOG_SWITCH_TO_FAILED: null,

  UPDATE_FILTER_LOG_SWITCH_TO_SUCCESS: null
})
